// extracted by mini-css-extract-plugin
export default {"wrapper":"Logo_wrapper__bVA8i","name":"Logo_name__Fzpqb","profession":"Logo_profession__WJQ6y"};